import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { SubDescription, MainHeadline } from 'components/Typography'
import { NavButton, OrangeButton } from 'components/Button'
import { StoreDeliveryFeeCard, StoreDeliveryFrozenFeeCard } from 'components/Card'
import {
  useConfirmDeliverFees,
  useFetchDeliveryFees,
  useHandleDeliveryFee,
  useHandleFrozenFee,
  useValidateDeliveryFees,
} from 'hooks/storeDeliveryFee'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getStoreRef } from 'reducks/auth/selectors'
import { ErrorMessage } from 'components/Error'
import { usePackageSizes, useRegionNameOptions } from 'hooks/masterData'

const StoreDeliveryFeeTemplate: FC = () => {
  const storeRef = useSelector((state: State) => getStoreRef(state))
  const regionNameOptions = useRegionNameOptions()
  const PACKAGE_SIZES = usePackageSizes()
  const storeDeliveryFees = useFetchDeliveryFees()
  const {
    addRegion,
    addSize,
    deliveryFees,
    feeType,
    handleDeliveryFeeAmount,
    handleFeeType,
    removeRegion,
    removeSize,
    selectRegion,
    selectSize,
  } = useHandleDeliveryFee(storeDeliveryFees, PACKAGE_SIZES, regionNameOptions)
  const handleFrozenFee = useHandleFrozenFee(deliveryFees, PACKAGE_SIZES, storeDeliveryFees)
  const { frozenFees } = handleFrozenFee
  const confirmDeliveryFees = useConfirmDeliverFees(deliveryFees, frozenFees, PACKAGE_SIZES, storeRef)
  const errors = useValidateDeliveryFees(deliveryFees)
  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'配送料設定'} />
      <Spacer size={20} />
      <SubDescription description={'配送料が設定されていないサイズは、商品登録できませんのでご注意ください。'} />
      <Spacer size={28} />
      <div id={'delivery-fee-bulk'}>
        <StoreDeliveryFeeCard
          addRegion={addRegion}
          addSize={addSize}
          deliveryFees={deliveryFees}
          feeType={'bulk'}
          handleDeliveryFeeAmount={handleDeliveryFeeAmount}
          handleFeeType={handleFeeType}
          isSelected={feeType === 'bulk'}
          label={'配送料を一括で設定する'}
          PACKAGE_SIZES={PACKAGE_SIZES}
          regionNameOptions={regionNameOptions}
          removeRegion={removeRegion}
          removeSize={removeSize}
          selectRegion={selectRegion}
          selectSize={selectSize}
        />
      </div>
      <Spacer size={8} />
      <div id={'delivery-fee-individual'}>
        <StoreDeliveryFeeCard
          addRegion={addRegion}
          addSize={addSize}
          deliveryFees={deliveryFees}
          feeType={'individual'}
          handleDeliveryFeeAmount={handleDeliveryFeeAmount}
          handleFeeType={handleFeeType}
          isSelected={feeType === 'individual'}
          label={'都道府県別に設定する'}
          PACKAGE_SIZES={PACKAGE_SIZES}
          regionNameOptions={regionNameOptions}
          removeRegion={removeRegion}
          removeSize={removeSize}
          selectRegion={selectRegion}
          selectSize={selectSize}
        />
      </div>
      <Spacer size={28} />
      <div id={'frozen-fee'}>
        <StoreDeliveryFrozenFeeCard PACKAGE_SIZES={PACKAGE_SIZES} {...handleFrozenFee} />
      </div>
      <Spacer size={48} />
      {errors.map((error) => (
        <React.Fragment key={error.caution}>
          <ErrorMessage caution={error.caution} id={error.id} />
          <Spacer size={20} />
        </React.Fragment>
      ))}
      <OrangeButton label={'確認する'} onClick={confirmDeliveryFees} size={'medium'} type={'main'} />
      <Spacer size={12} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      <Spacer size={72} />
    </div>
  )
}

export default StoreDeliveryFeeTemplate
